/// <amd-module name="typeahead/features/AATest" />
/// <amd-dependency path="jquery" name="$"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "HotelsLandingPage"],
        experiment: {
            id: 30503,
            name: "ESS_Test_ML_mimic_Client_Side",
            value: 1,
        },
        tabs: ["hotel"],
    },
];

export class AATest30503 implements IExperimentalFeature, IRequestUrlParamModifier {

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
        ISuggestServiceQueryParams {
        ExecutionHelper.shouldExecute(context, configuration);
        return params;
    }
}
